import React, { Suspense } from "react";
import VehicleInspection from "./VehicleInspection";

const RemoteUserInfo = React.lazy(() => 
  import("host/UserInfo").catch(() => ({ default: () => <div>加载失败</div> }))
);

const App: React.FC = () => {
  return (
    <div>
      <Suspense fallback={<div className="text-secondary" style={{ padding: "12px" }}>加载用户信息中...</div>}>
        <RemoteUserInfo title="Remote 用户信息 (订单检查)" showUpdateButton={false} />
      </Suspense>
      <div style={{ marginTop: "12px", marginBottom: "12px" }}>
        <button 
          onClick={() => {
            if (window.EventBus) {
              window.EventBus.emit("update-user-info-request");
            }
          }} 
          className="btn-primary"
        >
          从 Remote 更新用户信息
        </button>
      </div>
      <VehicleInspection />
    </div>
  );
};

export default App;

